import React, { useEffect, useState } from "react";
import { __ } from "services/Translator";

export default function Affiliates(props) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <>
      <div className="container-xxl">
        <center>
          <br />
          <br />
          <h1 style={{ color: "#fff" }}>{__("Affiliates")}</h1>
        </center>
      </div>
    </>
  );
}
